export var initialFileStorageState = {
  error: undefined,
  // Validate Public File URL
  validatePublicFileUrlStatus: null,
  validatePublicFileUrlOutput: null,
  // Upload File V2
  uploadFileV2Status: null,
  // Get Many File V2
  files: [],
  getManyFileV2Status: null,
  nextToken: undefined,
  // Delete File V2
  deleteFileV2Status: null,
  // Create File Storage V2
  createFileStorageV2Status: null,
  createFileStorageV2Output: null
};